import classnames from 'classnames';
import { Waypoint } from 'react-waypoint';
import { jsx as _jsx } from "react/jsx-runtime";

const GridItem = _ref => {
  let {
    children,
    item,
    width,
    onVisible,
    innerRef
  } = _ref;
  const content = item || children;
  const cssClasses = classnames('feed-grid__item', {
    ["feed-grid__item--".concat(String(width))]: width
  });
  return /*#__PURE__*/_jsx(Waypoint, {
    onEnter: callback => onVisible(callback),
    debug: false,
    scrollableAncestor: window,
    children: /*#__PURE__*/_jsx("div", {
      "data-testid": "grid-item",
      className: cssClasses,
      ref: innerRef,
      children: /*#__PURE__*/_jsx("div", {
        className: "feed-grid__item-content",
        children: /*#__PURE__*/_jsx("div", {
          className: "u-flex-grow u-fill-width",
          children: content
        })
      })
    })
  });
};

export default GridItem;